<template>
  <a-form
    class="mod-form mod-step1"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
    @submit="onSubmit"
  >
    <a-form-item label="账号类型">
      <a-input-group compact>
        <a-select size="large" v-model="accountType">
          <a-select-option value="LOGINNAME">
            用户名
          </a-select-option>
          <a-select-option value="PHONE">
            手机号
          </a-select-option>
          <a-select-option value="EMAIL">
            邮箱
          </a-select-option>
        </a-select>
        <a-input
          size="large"
          :placeholder="accountPlaceholder"
          v-decorator="[
            'accountInput',
            {
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
        >
        </a-input>
      </a-input-group>
    </a-form-item>
    <a-form-item label="个人信息">
      <a-input-group compact>
        <a-select size="large" v-model="infoType" @change="onInfoTypeChange">
          <a-select-option value="NAME">
            姓名
          </a-select-option>
          <a-select-option value="ID" v-if="userType === 0">
            证件号
          </a-select-option>
        </a-select>
        <a-input
          size="large"
          :placeholder="infoPlaceholder"
          v-decorator="[
            'infoValue',
            {
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
        >
        </a-input>
      </a-input-group>
    </a-form-item>
    <a-form-item label="验证码">
      <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
      </user-slider-captcha>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" type="primary" size="large" html-type="submit" :loading="loading">下一步</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { validate } from '@/utils/validate'
import { forgetPasswordCheckInfo } from '@/api/login'

const accountPlaceholderMap = {
  LOGINNAME: '请输入用户名',
  PHONE: '请输入手机号',
  EMAIL: '请输入邮箱号码'
}
const infoPlaceholderMap = {
  NAME: '请输入姓名',
  ID: '请输入证件号'
}

export default {
  props: {
    userType: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      accountType: 'LOGINNAME',
      infoType: 'NAME',
      token: '',
      loading: false
    }
  },
  computed: {
    accountPlaceholder () {
      return accountPlaceholderMap[this.accountType]
    },
    infoPlaceholder () {
      return infoPlaceholderMap[this.infoType]
    }
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      const { infoType } = this

      validate(infoType === 'NAME' ? 'forget-password-info' : 'forget-password-info-id', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const { token, accountType, infoType, userType } = this

          if (!token) {
            this.$error({
              content: '请拖动滑块完成验证！',
              centered: true
            })
            return
          }

          try {
            this.loading = true
            const data = await forgetPasswordCheckInfo({
              ...values,
              accountType,
              infoType,
              sliderCaptcha: token,
              type: userType
            })

            this.$emit('next', data)
          } catch (err) {
            this.$refs.verify.refresh()
            this.$error({
              content: err.message,
              centered: true
            })
            this.loading = false
          }
        }
      })
    },
    onInfoTypeChange () {
      this.form.validateFields(['infoValue'], { force: true })
    },
    onCaptchVerify (value) {
      this.token = value
    }
  }
}
</script>
